import script from "./TheSideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSideMenu.vue?vue&type=script&setup=true&lang=js"

import "./TheSideMenu.vue?vue&type=style&index=0&id=f5b6da10&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5b6da10"]])

export default __exports__